__turbopack_context__.v({
  "headerV2": "SearchResults-module-scss-module__JDqo5G__headerV2",
  "pagination": "SearchResults-module-scss-module__JDqo5G__pagination",
  "paginationDisabledItem": "SearchResults-module-scss-module__JDqo5G__paginationDisabledItem",
  "paginationItem": "SearchResults-module-scss-module__JDqo5G__paginationItem",
  "paginationLink": "SearchResults-module-scss-module__JDqo5G__paginationLink",
  "paginationList": "SearchResults-module-scss-module__JDqo5G__paginationList",
  "paginationRoot": "SearchResults-module-scss-module__JDqo5G__paginationRoot",
  "paginationSelectedItem": "SearchResults-module-scss-module__JDqo5G__paginationSelectedItem",
  "productLineCarousel": "SearchResults-module-scss-module__JDqo5G__productLineCarousel",
  "searchContainer": "SearchResults-module-scss-module__JDqo5G__searchContainer",
  "searchContainerFullWidth": "SearchResults-module-scss-module__JDqo5G__searchContainerFullWidth",
  "searchContainerWithProductLineCarousel": "SearchResults-module-scss-module__JDqo5G__searchContainerWithProductLineCarousel",
  "searchHits": "SearchResults-module-scss-module__JDqo5G__searchHits",
  "searchResults": "SearchResults-module-scss-module__JDqo5G__searchResults",
});
